<template>
  <profile-edit-section-card
    v-if="localState"
    title="Other services"
    breadcrumb-label="Profile"
    :saving="isSaving"
    :has-unsaved-changes="hasUnsavedChanges"
    @breadcrumb-click="cancelEdit"
    @save="handleSave"
    @cancel="cancelEdit"
  >
    <fieldset>
      <legend class="form__label pb-8">Qualifications</legend>
      <poppins-checkbox
        v-model="computedCheckboxes.dogCPR"
        checkbox-id="dog-cpr"
        name="dog-cpr"
        label-name="Dog CPR training"
        @change="toggleQualification('DOG_CPR')"
      />
      <poppins-checkbox
        v-model="computedCheckboxes.dogFirstAid"
        checkbox-id="dog-first-aid"
        name="dog-first-aid"
        label-name="Dog First Aid training"
        @change="toggleQualification('DOG_FIRST_AID')"
      />
      <poppins-checkbox
        v-model="computedCheckboxes.oralMedication"
        checkbox-id="oral-medication"
        name="oral-medication"
        label-name="Can administer oral medication"
        @change="toggleQualification('ORAL_MEDICATION')"
      />
      <poppins-checkbox
        v-model="computedCheckboxes.injectedMedication"
        checkbox-id="injected-medication"
        name="injected-medication"
        label-name="Can administer injected medication"
        @change="toggleQualification('INJECTED_MEDICATION')"
      />
    </fieldset>
  </profile-edit-section-card>
</template>

<script lang="ts">
import ProfileEditSectionCard from '../../components/ProfileEditSectionCard.vue';
import PoppinsCheckbox from '@/components/checkbox/Checkbox.vue';
import profileEditMixin from '../../mixins/profileEditMixin';
import { PetCareProfileFormState } from '../../__types__/PetCareProfileTypes.js';

export default {
  name: 'PetCareServicesForm',
  components: {
    ProfileEditSectionCard,
    PoppinsCheckbox,
  },
  mixins: [profileEditMixin],
  data(): any {
    return {
      localState: null,
      originalState: null,
    };
  },
  computed: {
    hasUnsavedChanges(): boolean {
      if (!this.localState || !this.originalState) return false;
      return JSON.stringify(this.localState) !== JSON.stringify(this.originalState);
    },
    computedCheckboxes() {
      return {
        dogCPR: this.localState?.qualifications.includes('DOG_CPR') || false,
        dogFirstAid: this.localState?.qualifications.includes('DOG_FIRST_AID') || false,
        oralMedication: this.localState?.qualifications.includes('ORAL_MEDICATION') || false,
        injectedMedication: this.localState?.qualifications.includes('INJECTED_MEDICATION') || false,
      };
    },
  },
  watch: {
    $route() {
      this.initializeFormState();
    },
    formState: {
      handler(newState) {
        if (newState) {
          this.initializeFormState();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.initializeFormState();
  },
  methods: {
    toggleQualification(qualification: string) {
      if (!this.localState) return;

      const index = this.localState.qualifications.indexOf(qualification);
      if (index === -1) {
        this.localState.qualifications = [...this.localState.qualifications, qualification];
      } else {
        const qualificationsCopy = [...this.localState.qualifications];
        qualificationsCopy.splice(index, 1);
        this.localState.qualifications = qualificationsCopy;
      }
    },
    initializeFormState() {
      const state = this.formState as PetCareProfileFormState | null;
      if (!state) return;

      this.localState = {
        qualifications: state.qualifications || [],
      };
      this.originalState = JSON.parse(JSON.stringify(this.localState));
    },
    async handleSave() {
      if (!this.localState) return;

      if (this.hasUnsavedChanges) {
        await this.saveSection({
          qualifications: this.localState.qualifications,
        });
      }
    },
  },
};
</script>
